import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { closeApp, isMobileDevice } from "utils/Functions"
import { queryTx } from "utils/RpcHelper"

export function TxLoadingPage() {
    const { txHash } = useParams()
    const [isComplete, setIsComplete] = useState<boolean>()

    const queryTxHash = async (retry: number) => {
        if (retry === 10) return false;
        try {
            const tx = await queryTx(txHash!)
            JSON.parse(tx!.rawLog)
            return true;
        } catch (e) {
            await new Promise((res, rej) => setTimeout(() => res(undefined), 1000))
            return queryTxHash(++retry)
        }
    }


    const loadTx = async () => {
        const result = await queryTxHash(1)
        setIsComplete(result)
    }

    useEffect(() => {
        loadTx()
    }, [])

    return <div style={{ height: "100vh" }} className="w-100 p-2 px-4 d-flex justify-content-center align-items-center">
        <div className="row">
            <div className="col-12">
                {
                    isComplete == undefined && <div className="m-auto loader"></div>
                }
                {
                    isComplete && <div className="alert alert-success">
                        Transaction Success
                        &nbsp;
                        <a target="_blank" href={`https://finder.terra-classic.hexxagon.dev/mainnet/tx/${txHash}`}>explorer</a>
                    </div>
                }
                {
                    isComplete == false && <div className="alert alert-danger">
                        Transaction Failed
                        &nbsp;
                        <a target="_blank" href={`https://finder.terra-classic.hexxagon.dev/mainnet/tx/${txHash}`}>explorer</a>
                    </div>
                }
            </div>
            {
                isComplete != undefined && <div className="col-12">
                    <button onClick={closeApp} className="btn btn-primary btn-block w-100 btn-lg">Back</button>
                </div>
            }

        </div>
    </div>
}